<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Activated Compliance Certificate</strong>
    </span>
    <span style="float:right">
      <!-- <a [routerLink]="['/complianceCertificate/add']"> -->
        <button class="btn btn-success pull-right" (click)="addComplianceCertificate()" class="btn btn-sm btn-primary mb-2" type="button">
          <em class="fa fa-plus"></em>Add Compliance Certificate
        </button>
      <!-- </a> -->
    </span>
  </div>

  <section class="card search-box">
    <div class="card-header" data-toggle="collapse" data-target="#search-div">Modify Search <span class="pull-right"><i
          class="fa fa-filter" aria-hidden="true"></i></span> </div>
    <div id="search-div" class="card-block collapse">
      <div class="row">
        <div class="col-md-6">
          <label class="form-control-label">Certificate For</label>
        </div>
        <div class="col-md-3">
          <label class="form-control-label">Periodicity</label>
        </div>
        <div class="col-md-3">
          <label class="form-control-label">&nbsp;</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <div class="radio-options-group-certificate">
              <div class="md-radio md-radio-inline">
                <input id="IsPredefinedEventTaskYes" type="radio"
                  name="TaskuserdefinedorPredefinedEventTask" [(ngModel)]="searchParam.certificateFor" value='Individual'
                  class="form-check-input">
                <label for="IsPredefinedEventTaskYes">Individual</label>
              </div>
              <div class="md-radio md-radio-inline">
                <input id="IsPredefinedEventTaskNo" type="radio"
                  name="TaskuserdefinedorPredefinedEventTask" [(ngModel)]="searchParam.certificateFor" value='Particular'
                  class="form-check-input">
                <label for="IsPredefinedEventTaskNo">Particular Dept/Branch</label>
              </div>
              <div class="md-radio md-radio-inline">
                <input id="IsPredefinedEventTaskNo1" type="radio"
                  name="TaskuserdefinedorPredefinedEventTask" [(ngModel)]="searchParam.certificateFor" value='All'
                  class="form-check-input">
                <label for="IsPredefinedEventTaskNo1">All Dept/Branch</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <select id="groupdropdown" [(ngModel)]="searchParam.periodicityId" class="form-control select">
              <option [value]=null>Select</option>
              <option *ngFor="let periodicity of periodicityData" value={{periodicity._id}}>
                {{periodicity.Name}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group filter-actions-certificate">
            <button type="button" (click)="getMasterActivatedComplianceCertificate()"
              class="btn btn-sm btn-primary" title="search">
              <em class="fa fa-search"></em>Search
            </button>
            <button type="button" class="btn btn-sm btn-default btn-clear" (click)="clear();getMasterActivatedComplianceCertificate()"
              title="refresh">
              <em class="fa fa-refresh"></em>Clear
            </button>
          </div>
        </div>

      </div>
    </div>
  </section>

  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <div class="table-responsive">
            <table id="compliance" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
              class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
              <caption></caption>
              <thead>
                <tr>
                  <th scope="row">Certificate Name</th>
                  <th scope="row">Individual OR Branch / Department</th>
                  <th scope="row">Periodicity</th>
                  <th scope="row" class="group-list-action"><span>Action</span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of masterComplianceCertificateData;">
                  <td tabindex="1">{{data.CertificateName }}</td>
                  <td tabindex="1">{{data.certificateFor == 'All' ? 'All Branch / Department' : (data.certificateFor ==
                    'Particular' ? 'Particular Branch / Department' : 'Individual') }}</td>
                  <td tabindex="1">{{data.periodicityId.Name }}</td>
                  <td class="group-list-action">
                    <button type="button" class="btn-sm btn btn-warning"
                      (click)="getActivatedComplianceCertificateByMasterId(data._id)">
                      <span class="fa fa-eye"></span>
                    </button>&nbsp;&nbsp;&nbsp;
                    <!-- <button type="button" class="btn-sm btn btn-danger" (click)="deleteConfirmation(data._id)"
                      >
                      <span class="icmn-bin"></span>
                    </button> -->
                  </td>
                </tr>

                <tr *ngIf="!dataAvailable">
                  <td style="text-align: center;">No Data Available</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="certificateDetails" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px; vertical-align: middle">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDeletion">
            <em class="fa fa-question-circle-o mr-2"></em>Activated Compliance Certificate
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <em class="fa fa-times"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table id="activatedCert" datatable [dtOptions]="dtOptionsForDetails" [dtTrigger]="dtTriggerForDetails"
                  class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                  <caption></caption>
                  <thead>
                    <tr>
                      <th scope="row">Certificate Name</th>
                      <th scope="row">Individual OR Branch / Department</th>
                      <th scope="row">Periodicity</th>
                      <th scope="row">Due Date</th>
                      <th scope="row">Submitted By</th>
                      <th scope="row" class="group-list-action"><span>Action</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of activatedComplianceCertificateData;">
                      <td tabindex="1">{{data.CertificateName }}</td>
                      <td tabindex="1">{{data.certificateFor == 'All' ? 'All Branch / Department' : (data.certificateFor
                        ==
                        'Particular' ? 'Particular Branch / Department' : 'Individual') }}</td>
                      <td tabindex="1">{{data.periodicityId.Name }}</td>
                      <td tabindex="1">{{data.dueDate|date: 'dd/MM/yyyy' }}</td>
                      <td tabindex="1">{{data.submittedByName }}</td>
                      <td class="group-list-action">
                        <button type="button" class="btn-sm btn btn-warning"
                          (click)="editComplianceCertificate(data._id)">
                          <span class="fa fa-pencil"></span>
                        </button>&nbsp;&nbsp;&nbsp;
                    </tr>

                    <tr *ngIf="!dataAvailable">
                      <td style="text-align: center;">No Data Available</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <em class="fa fa-times"></em>Close</button>
        </div>
      </div>
    </div>
  </div>

  <app-alert></app-alert>
</section>